<template>
    <div v-show="visible" class="modal fade show" :id="id" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="staticBackdropLabel" aria-modal="true" style="display: block">
        <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title fs-3" id="staticBackdropLabel">{{ title }}</h5>
                </div>
                <div class="modal-body">
                    <p class="fs-4">{{ text }}</p>
                    <slot name="motivo" />
                </div>
                <div class="modal-footer" v-if="aviso">
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="ok">Ok</button>
                </div>
                <div class="modal-footer" v-else>
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="ok">Sim</button>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="cancelar">Não</button>
                </div>
            </div>
        </div>

    </div>
    <div v-show="visible" class="modal-backdrop fade show" id="backdrop"></div>
</template>

<script setup>
import { defineComponent } from 'vue';
import { reactive, onMounted, computed, defineProps, defineEmits } from 'vue';

const emits = defineEmits(['modalResult']);

const props = defineProps(['visible', 'title', 'id', "text", 'aviso']);

function ok() {
    emits("modalResult", "ok", props.id);
}

function cancelar() {
    emits("modalResult", "cancel", props.id);
}

</script>

<style scoped>
.modal-content {
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}

@media only screen and (min-width:1014px) {
    .modal-dialog {
        max-width: 50% !important;
    }
}
</style>